import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scanCachedMatchDescription: {
    id: 'app.inventory.scan.cachedMatchDescription',
  },
  scanCreate: {
    id: 'app.inventory.scan.create',
  },
  scanDescription: {
    id: 'app.inventory.scan.description',
  },
  scanErrorSearchLocalCache: {
    id: 'app.inventory.scan.errorSearchLocalCache',
  },
  scanExistingMeterFound: {
    id: 'app.inventory.scan.existingMeterFound',
  },
  scanExistingMeterFoundTitle: {
    id: 'app.inventory.scan.existingMeterFoundTitle',
  },
  scanInvalidSearchValue: {
    id: 'app.inventory.scan.invalidSearchValue',
  },
  scanMatchedBy: {
    id: 'app.inventory.scan.matchedBy',
  },
  scanMeterTypeMatchedBy: {
    id: 'app.inventory.scan.meterTypeMatchedBy',
  },
  scanNoMeterFound: {
    id: 'app.inventory.scan.noMeterFound',
  },
  scanOpenQueuedMeter: {
    id: 'app.inventory.scan.openQueuedMeter',
  },
  scanOtherLocationWarning: {
    id: 'app.inventory.scan.otherLocationWarning',
  },
  scanPlaceholder: {
    id: 'app.inventory.scan.placeholder',
  },
  scanQueuedMatchDescription: {
    id: 'app.inventory.scan.queuedMatchDescription',
  },
  scanRunPassport: {
    id: 'app.inventory.scan.runPassport',
  },
  scanScanOrType: {
    id: 'app.inventory.scan.scanOrType',
  },
  scanSearching: {
    id: 'app.inventory.scan.searching',
  },
  scanSessionSummary: {
    id: 'app.inventory.scan.sessionSummary',
  },
  scanSkip: {
    id: 'app.inventory.scan.skip',
  },
  scanTitle: {
    id: 'app.inventory.scan.title',
  },
  scanUpdate: {
    id: 'app.inventory.scan.update',
  },
  scanUpdateMeter: {
    id: 'app.inventory.scan.updateMeter',
  },
});
